<template>
  <audio
    autoplay
    :muted="muted"
    v-show="showAudio"
    :ref="(el) => setVideoAudioRefs(el, jitsiUserId)"
  />
  <video
    :data-user-id="jitsiUserId"
    muted
    autoplay
    playsinline
    v-show="showVideo"
    :class="{ 'opacity-60': streamMuted }"
    :ref="(el) => setVideoAudioRefs(el, jitsiUserId)"
    class="absolute top-0 left-0 h-full w-full object-cover rounded-2xl"
  />
</template>

<script>
import { computed } from 'vue';
import useLocalStreamingDevicesStore from '@/Stores/useLocalStreamingDevicesStore';

export default {
  name: 'StreamPlayerRemote',
  props: {
    jitsiUserId: {
      type: [String, Number],
    },
    streamMuted: {
      type: Boolean,
      default: false,
    },
    showVideo: {
      type: Boolean,
      default: true,
    },
    showAudio: {
      type: Boolean,
      default: true,
    },
    isAudioMuted: {
      type: Boolean,
      default: false,
    },
    setVideoAudioRefs: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const multiCameraStore = useLocalStreamingDevicesStore();
    const muted = computed(() => {
      if (multiCameraStore.externalAudioIO) return true;
      return props.isAudioMuted;
    });

    return { muted };
  },
};
</script>
